import { render, staticRenderFns } from "./formGoodsList.vue?vue&type=template&id=63c3c412&scoped=true&"
import script from "./formGoodsList.vue?vue&type=script&lang=js&"
export * from "./formGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./formGoodsList.vue?vue&type=style&index=0&id=63c3c412&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c3c412",
  null
  
)

export default component.exports